export var GRAVITY = 9.8067;
export var G_TO_METER_PER_SEC_SQUARED = 9.80665;
//# sourceMappingURL=constants.js.map